// sagas.ts
import {
  call,
  CallEffect,
  put,
  PutEffect,
  takeLatest,
} from "redux-saga/effects";
import * as AuthService from "../../service/auth-service/auth-services";
import {
  EX_TOKEN_REQUEST,
  LOGIN_REQUEST,
  loginFailure,
  LoginFailurePayload,
  LoginRequestPayload,
  loginSuccess,
  LoginSuccessPayload,
  LOGOUT_REQUEST,
  logoutFailure,
  LogoutFailurePayload,
  logoutSuccess,
  LogoutSuccessPayload,
} from "./action";
import { message } from "antd";

interface LoginResponse {
  data: {
    token: string;
    refreshToken: string;
    user: JSON;
  };
}

function* loginSaga(action: {
  type: string;
  payload: LoginRequestPayload;
}): Generator<
  | CallEffect<LoginResponse>
  | PutEffect<{
    type: string;
    payload: LoginSuccessPayload | LoginFailurePayload;
  }>,
  void,
  LoginResponse
> {
  try {
    const response: LoginResponse = yield call(
      AuthService.loginUser,
      action.payload
    );

    const { data } = response;
    localStorage.setItem('token', data.token);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));

    yield put(loginSuccess(data));
    message.success("Đăng nhập thành công!");

  } catch (error: any) {
    localStorage.clear();
    console.log("ERROR FULL:", error);

    let errorMessage = "Đăng nhập thất bại";

    const status = error?.response?.status;

    if (status === 401) {
      errorMessage = "Sai tên đăng nhập hoặc mật khẩu";
    } else if (!error.response) {
      errorMessage = "Không thể kết nối đến server";
    } else {
      errorMessage =
        error.response?.data?.message || "Có lỗi xảy ra, vui lòng thử lại";
    }

    message.error(`Đăng nhập thất bại: ${errorMessage}`);

    yield put(loginFailure({ error: errorMessage }));
  }
}

// function* registerSaga(action: {
//   type: string;
//   payload: RegisterRequestPayload;
// }) {
//   try {
//     const response: LoginResponse = yield call(
//       AuthService.registerUser,
//       action.payload
//     );
//     const { data } = response;
//     console.log("Data : ", data);
//     alert("Registration successful!");
//     yield put(registerSuccess(data));
//   } catch (error: any) {
//     console.log(error);
//     const errorMessage = error?.response.data.message || "Registration failed";
//     alert(`Registration failed: ${errorMessage}`);
//     yield put(registerFailure({ error: errorMessage + "" }));
//   }
// }

function* logoutSaga(): Generator<
  | CallEffect<void>
  | PutEffect<{
    type: string;
    payload: LogoutSuccessPayload | LogoutFailurePayload;
  }>,
  void,
  void
> {
  try {
    yield call(AuthService.logout);
    message.success("Đăng xuất thành công!");
    // alert("Logout successful!");
    yield put(logoutSuccess({}));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || "Đăng xuất thất bại";
    message.error(`Đăng xuất thất bại: ${errorMessage}`);
    yield put(logoutFailure({ error: error.message }));
  }
}

function* exToken(): Generator<
  | CallEffect<void>
  | PutEffect<{
    type: string;
    payload: LogoutSuccessPayload | LogoutFailurePayload;
  }>,
  void,
  void
> {
  try {
    yield call(AuthService.logout);
    message.success("Hết phiên truy cập");
    // alert("Logout successful!");
    yield put(logoutSuccess({}));
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || "Logout failed";
    alert(`Logout failed: ${errorMessage}`);
    yield put(logoutFailure({ error: error.message }));
  }
}

export default function* watchAuthSaga() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
  // yield takeLatest(REGISTER_REQUEST, registerSaga);
  yield takeLatest(LOGOUT_REQUEST, logoutSaga);
  yield takeLatest(EX_TOKEN_REQUEST, exToken);
}